import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function GearCard({
  id,
  icon,
  title,
  items,
  hint,
  tone = 'warm',
  children,
  className = '',
}) {
  const classes = ['gear-card', `gear-card--${tone}`, className].filter(Boolean).join(' ');

  return (
    <article id={id} className={classes}>
      <header className="gear-card__head">
        {icon ? <div className="gear-card__icon">{icon}</div> : null}
        <div className="gear-card__title">{title}</div>
      </header>

      {items && items.length > 0 ? (
        <div className="gear-card__list">
          {items.map((item, i) => (
            <div key={i} className="gear-card__line">{item}</div>
          ))}
        </div>
      ) : null}

      {children}

      {hint ? <p className="gear-card__hint">{hint}</p> : null}
    </article>
  );
}

GearCard.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  items: PropTypes.arrayOf(PropTypes.node),
  hint: PropTypes.node,
  tone: PropTypes.oneOf(['warm', 'cool', 'gold']),
  children: PropTypes.node,
  className: PropTypes.string,
};
